//@ts-nocheck
/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import { FeatureFlag } from "../FeatureFlag";

export const CalculationDataSourceReuse: FeatureFlag = {"Id":"CalculationDataSourceReuse","Label":"[10.24]Reuse hinted datasource calculation rows","Impact":"When enabled, supported hinted ForEach child datasource calculations can reuse rows from an earlier upstream datasource-backed calculation instead of issuing a second lookup. When disabled, those lookups continue using the existing backend path.","Mode":1,"ActiveOn":null,"ActiveUntil":null,"GlobalEnabled":false,"TenantEnabled":null,"UserEnabled":null,"Scope":7};
